if (!customElements.get('matching-products')) {
  customElements.define(
    'matching-products',
    class MatchingProducts extends HTMLElement {
      constructor() {
        super();
        this.data = this.readData();
        this.variantChangeUnsubscriber = undefined;
      }

      connectedCallback() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      readData() {
        const dataScript = this.querySelector('[data-matching-products-json]');
        if (!dataScript) return null;

        try {
          return JSON.parse(dataScript.textContent);
        } catch (error) {
          console.error('Matching products data could not be parsed', error);
          return null;
        }
      }

      handleVariantChange({ data }) {
        if (!data?.variant || data.sectionId !== this.dataset.sectionId) return;
        this.updateForVariant(data.variant);
      }

      updateForVariant(variant) {
        if (!this.data || this.data.currentFinishIndex < 0) return;

        const selectedFinish = variant.options?.[this.data.currentFinishIndex];
        if (!selectedFinish) return;

        const finishElement = this.querySelector('[data-matching-finish] span');
        if (finishElement) finishElement.textContent = selectedFinish;

        this.querySelectorAll('[data-matching-card]').forEach((card) => {
          const product = this.data.products.find((item) => String(item.id) === String(card.dataset.productId));
          if (!product) return;

          const variantMatch = this.findMatchingVariant(product, selectedFinish);
          if (!variantMatch) return;

          const hasSameFinish = product.finishIndex > -1 && this.normalise(variantMatch.options?.[product.finishIndex]) === this.normalise(selectedFinish);
          this.updateCard(card, variantMatch, selectedFinish, hasSameFinish);
        });
      }

      findMatchingVariant(product, selectedFinish) {
        if (!product.variants?.length) return null;

        if (product.finishIndex < 0) {
          return product.variants.find((variant) => variant.available) || product.variants[0];
        }

        const selectedFinishNormalised = this.normalise(selectedFinish);
        const sameFinishVariants = product.variants.filter(
          (variant) => this.normalise(variant.options?.[product.finishIndex]) === selectedFinishNormalised
        );

        return sameFinishVariants.find((variant) => variant.available) || sameFinishVariants[0] || product.variants.find((variant) => variant.available) || product.variants[0];
      }

      updateCard(card, variant, selectedFinish, hasSameFinish) {
        const link = card.querySelector('[data-matching-link]');
        const titleLink = card.querySelector('[data-matching-title-link]');
        const button = card.querySelector('[data-matching-button]');
        const image = card.querySelector('[data-matching-image]');
        const variantInput = card.querySelector('[data-matching-variant-input]');
        const addButton = card.querySelector('[data-matching-add]');
        const badge = card.querySelector('[data-card-badge]');
        const meta = card.querySelector('[data-card-meta]');

        [link, titleLink, button].forEach((element) => {
          if (element) element.href = variant.url;
        });

        if (image && variant.image) {
          image.src = variant.image;
          image.alt = variant.imageAlt || image.alt;
        }

        if (variantInput) variantInput.value = variant.id;

        if (addButton) {
          addButton.disabled = !variant.available;
          addButton.textContent = variant.available ? this.data.quickAddLabel : this.data.soldOutLabel;
        }

        if (badge) badge.textContent = hasSameFinish ? this.data.cardSameFinishBadge : this.data.cardFallbackBadge;
        if (meta) {
          meta.textContent = hasSameFinish
            ? `${this.data.sameFinishMetaLabel} ${selectedFinish}`
            : this.data.fallbackMatchLabel;
        }
      }

      normalise(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/\(pvd\)|pvd/g, '')
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-|-$/g, '');
      }
    }
  );
}
